import { render, staticRenderFns } from "./RotationEdit.vue?vue&type=template&id=2520fab2&"
import script from "./RotationEdit.vue?vue&type=script&lang=js&"
export * from "./RotationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports